import { __decorate, __metadata } from "tslib";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import BaseMixer from "../../BaseMixer";
import { IDetailedNotificationDTO } from "@/store/models/notification/DetailedNotification";
import { NotificationsModule } from "@/store/modules/notification.module";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let ReviewMeetingNotificationComponent = /** @class */ (() => {
    var _a;
    let ReviewMeetingNotificationComponent = class ReviewMeetingNotificationComponent extends Mixins(BaseMixer) {
        UpdateIsActive(notification) {
            if (!notification.isComplete) {
                return;
            }
            NotificationsModule.UpdateIsActive(notification.id);
            if (notification.notificationData.isAdmin) {
                this.$router.push({ name: "CycleListing" });
            }
            else {
                this.$router.push({ name: "ReviewListing" });
            }
        }
        UpdateIsSeen() {
            NotificationsModule.UpdateIsSeen(this.notification.id);
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IDetailedNotificationDTO !== "undefined" && IDetailedNotificationDTO) === "function" ? _a : Object)
    ], ReviewMeetingNotificationComponent.prototype, "notification", void 0);
    ReviewMeetingNotificationComponent = __decorate([
        Component({
            name: "ReviewMeetingNotificationComponent",
            components: {},
        })
    ], ReviewMeetingNotificationComponent);
    return ReviewMeetingNotificationComponent;
})();
export default ReviewMeetingNotificationComponent;
